import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { StrictMode } from "react";
import * as Sentry from "@sentry/react";
import { runAttributionCapture } from "./lib/attribution";
import { loadOpenAiPixel } from "./lib/helpers/openAiPixelHelper";

// Initialize Sentry
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration()
  ],
  // Performance Monitoring
  tracesSampleRate: import.meta.env.VITE_SENTRY_ENVIRONMENT === "production" ? 0.1 : 1.0,
  // Session Replay
  replaysSessionSampleRate: import.meta.env.VITE_SENTRY_ENVIRONMENT === "production" ? 0.1 : 1.0,
  replaysOnErrorSampleRate: 1.0,
});

runAttributionCapture();

// Only production sets the Pixel ID, so dev and QA never send OpenAI Ads events.
loadOpenAiPixel(import.meta.env.VITE_OPENAI_ADS_PIXEL_ID);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
